import { INVESTMENT_PROFILE_TYPE_SDIRA } from "@components/Domain"


const isSdiraInvestment = ({ profileType }) => {
  return profileType === INVESTMENT_PROFILE_TYPE_SDIRA
}

export default isSdiraInvestment
